import {reduce} from 'lodash'
import {resizeTextToFitBoundingBox} from 'powtoon-commons/utils/measureText'

export default function text(track, trackSlugsData) {
  const trackAfterReplaceText = replaceText(track, trackSlugsData)
  return resizeTextToFitBoundingBox( trackAfterReplaceText)
}

function replaceText(track, trackSlugsData){
  
  //let newTrack = track
  const rv = reduce(trackSlugsData, (newTrack, {slug, slugNewValue}) => {
    const sprite = newTrack.sprites[0]
    const stringToReplace = `[${slug}]`
    return {
      ...newTrack,
      sprites: [
        {
          ...sprite,
          text: sprite.text.replace(stringToReplace, slugNewValue)
        }
      ]
    }
  }, track)
  return rv
}